import React, { useState } from 'react';
import PublicLayout from './PublicLayout';

const TELEGRAM_BOT_URL = 'https://t.me/NotreenVpnBot';

export default function LoginPage({ onLogin }) {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const isCodeComplete = code.length === 6;

  const changeCode = (event) => {
    setCode(event.target.value.replace(/\D/g, '').slice(0, 6));
    setError('');
  };

  const submit = async (event) => {
    event.preventDefault();
    if (!isCodeComplete || isLoading) return;
    setIsLoading(true);
    setError('');
    try {
      await onLogin({ code });
    } catch (requestError) {
      setError(requestError.response?.status === 401
        ? 'Код не подошёл. Получите новый в боте и попробуйте ещё раз.'
        : 'Не удалось выполнить вход. Попробуйте ещё раз.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PublicLayout isLogin>
      <section className="public-login" aria-labelledby="login-title">
        <div className="login-intro">
          <p className="public-eyebrow"><span /> РАДЫ ВАС ВИДЕТЬ</p>
          <h1 id="login-title">С возвращением<br />в <em>свой круг.</em></h1>
          <p>Для входа понадобится только код из нашего Telegram-бота. Пароль придумывать не нужно.</p>
          <a className="public-back-link" href="/">← На главную</a>
        </div>
        <form className="public-login-card" onSubmit={submit} aria-label="Вход в Notreen" aria-busy={isLoading}>
          <p className="public-eyebrow">ЛИЧНЫЙ КАБИНЕТ</p>
          <h2>Вход в Notreen</h2>
          <p className="login-card-copy">Откройте бота, нажмите «Получить код» и ответьте на его вопрос.</p>
          <a className="public-telegram-button" href={TELEGRAM_BOT_URL} rel="noopener noreferrer" target="_blank">
            <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M21.7 3.6 18.4 20c-.2 1.1-.9 1.4-1.8.9l-5.1-3.8-2.5 2.4c-.3.3-.5.5-1 .5l.4-5.2 9.4-8.5c.4-.4-.1-.6-.6-.3L5.6 13.3.6 11.7c-1.1-.3-1.1-1.1.2-1.6L20.4 2.6c.9-.3 1.7.2 1.3 1Z" /></svg>
            Получить код в Telegram <span className="public-sr-only">(в новой вкладке)</span><span aria-hidden="true">↗</span>
          </a>
          <div className="login-divider"><span>Уже получили код?</span></div>
          <label className="public-code-label" htmlFor="access-code">Код из Telegram</label>
          <input id="access-code" className="public-code-input" autoComplete="one-time-code" inputMode="numeric"
            pattern="[0-9]{6}" value={code} onChange={changeCode} type="text" placeholder="000000" required
            disabled={isLoading} aria-invalid={Boolean(error)} aria-describedby={error ? 'code-help code-error' : 'code-help'} />
          <p id="code-help" className="login-code-help">Шесть цифр из сообщения бота.</p>
          {error && <p id="code-error" className="public-form-error" role="alert">{error}</p>}
          <button className="public-primary-button" disabled={isLoading || !isCodeComplete} type="submit">
            {isLoading ? 'Проверяем код…' : 'Войти'} <span aria-hidden="true">→</span>
          </button>
        </form>
      </section>
    </PublicLayout>
  );
}
